import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";

const pieceCount = {
  subtle: 70,
  normal: 140,
  big: 260,
};

const ConfettiEffect = ({ intensity = "normal" }) => {
  const { width, height } = useWindowSize();

  if (intensity === "off") return null;

  return (
    <ReactConfetti
      width={width}
      height={height}
      numberOfPieces={pieceCount[intensity] || pieceCount.normal}
      gravity={intensity === "big" ? 0.05 : 0.035}
      recycle
    />
  );
};

export default ConfettiEffect;
